import { useTranslation } from "next-i18next";
import Image from "next/image";
import React, { FC, ReactNode } from "react";

import { useEth721Price } from "@/features/nft/hooks/useEth721Price";
import TextPlaceholder from "@/features/placeholder/TextPlaceholder";
import { NFTDisplayName } from "@/features/post/components/NFTDisplayName";
import { NFTPostContentMenuItem } from "@/features/post/components/NFTPostContentMenuItem";

export const NFTPostContentInfoCard: FC<{
  actionArea?: ReactNode;
  ownerAddress: string;
  isListed?: boolean;
  listedPrice?: string; //in wei
  serviceFee?: string; // in wei
  loading?: boolean;
  isNftOwner?: boolean;
  tokenId: string;
}> = (props) => {
  const {
    actionArea,
    loading = true,
    isNftOwner = false,
    ownerAddress,
    isListed,
    tokenId,
  } = props;

  const { t } = useTranslation(["post", "common"]);
  const prices = useEth721Price(tokenId);
  const {
    price,
    priceInEth,
    priceInUsd,
    commissionFeeInEth,
    royaltyFeeInEth,
    formattedRoyaltyChargePercentage,
    formattedServiceChargePercentage,
  } = prices ?? {};

  if (loading || !prices) {
    return (
      <div className="bg-white divide-y divide-gray-300 rounded-md shadow-xl border border-transparent p-5 z-20">
        <div className="">
          <NFTPostContentMenuItem
            lowerContent={<NFTDisplayName walletAccount={ownerAddress} />}
            upperContent={t("post:nft.owner")}
            walletAccount={ownerAddress}
            loading={loading}
            imageAlt={"this is the guy offering highest bid"}
            withBy={true}
            withBorder={false}
          />
          <div className="flex space-x-3 items-baseline mt-4">
            <div className="w-36">
              <TextPlaceholder size={"lg"} />
            </div>
            <div className="w-28">
              <TextPlaceholder size={"sm"} />
            </div>
          </div>

          <div className="w-full my-4">{actionArea}</div>
        </div>
        <div className="pt-4 flex justify-between">
          <div className="w-36">
            <TextPlaceholder />
          </div>
          <div className="w-24">
            <TextPlaceholder />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white divide-y divide-gray-300 rounded-md shadow-xl border border-transparent p-5 z-20">
      <div className="">
        <NFTPostContentMenuItem
          lowerContent={<NFTDisplayName walletAccount={ownerAddress} />}
          upperContent={t("post:nft.owner")}
          walletAccount={ownerAddress}
          loading={loading}
          imageAlt={"this is the guy offering highest bid"}
          withBy={true}
          withBorder={false}
        />
        {/* {asset.sellOrders.length > 0 ? ( */}
        {isListed && Number(price) > 0 ? (
          <div className="flex space-x-3 items-baseline mt-4 w-full overflow-hidden flex-wrap">
            <div className="flex items-baseline space-x-1">
              <div className="w-6 h-6">
                <Image
                  src={"/assets/nft/EthIcon.svg"}
                  alt={"this is the icon of ETH"}
                  width={150}
                  height={150}
                />
              </div>
              <div className="text-3xl font-bold truncate">{priceInEth}</div>
            </div>
            {/* TODO: write a function convert bigNumber to USD/HKD */}
            <div className="text-gray-500 truncate">${priceInUsd}</div>
          </div>
        ) : (
          !isNftOwner && (
            <div className="mt-4 text-2xl">{t("common:nft.forSaleSoon")}</div>
          )
        )}
        <div className={`w-full ${actionArea && "my-4"} overflow-hidden`}>
          {actionArea}
        </div>
      </div>
      <div className="flex flex-col pt-4">
        <div className="flex justify-between">
          {/* TODO: write a function calculate the service fee */}
          <div>
            {t("post:nft.serviceFee")}{" "}
            <div className="font-black text-black inline">
              {formattedServiceChargePercentage}
            </div>
          </div>
          {isListed && <div>ETH {commissionFeeInEth}</div>}
        </div>
        <div className="flex justify-between pt-1">
          {/* TODO: write a function calculate the service fee */}
          <div>
            {t("post:nft.royaltyFee")}{" "}
            <div className="font-black text-black inline">
              {formattedRoyaltyChargePercentage}
            </div>
          </div>
          {isListed && <div>ETH {royaltyFeeInEth}</div>}
        </div>
      </div>
    </div>
  );
};
